import { inject, autoinject, LogManager, bindable } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { Logger } from 'aurelia-logging';
import { Endpoint, Rest } from 'aurelia-api';
import { ControllerValidateResult, ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { BootstrapFormRenderer } from '../../services/bootstrap-form-renderer';
import { Helpers } from '../../services/helpers';
import { UserViewModel } from '../../models/userview-model';
import { UserEditViewModel } from '../../models/usereditview-model';

@autoinject
export class UsersModalUpdate {
	@bindable id: number = 0;
	private model: UserViewModel;
    private logger: Logger = LogManager.getLogger('USERMODALUPDATE');
    private validationController: ValidationController | null = null;
    private saveDisabled: boolean = false;

    constructor(@inject(Endpoint.of('api')) private api: Rest,
        private validationControllerFactory: ValidationControllerFactory,
        private dialogController: DialogController) {
        this.validationController = validationControllerFactory.createForCurrentScope();

        this.validationController.addRenderer(new BootstrapFormRenderer());
    }

    async activate(params: any) {
        this.logger.debug('activate');
        this.id = params.userId;

        await this.getModel();
    }

    async getModel() {
        this.logger.debug('getModel');

        await this.api.find('/User/GetById', this.id)
            .then(async (data: UserViewModel) => {
                this.logger.debug('Success getModel: ', data);
                this.model = new UserViewModel(data);
            }).catch(async (err) => {
                this.logger.debug('Error getModel: ', err);
                await Helpers.ParseValidationError(err, this.validationController, this.model);
            });
    }


    async save() {
        this.logger.debug('save');
        this.saveDisabled = true;

        const validation: ControllerValidateResult = await this.validationController.validate();

        if (validation) {
            await this.api.update('/User/Update', this.id, this.model)
                .then((data: UserEditViewModel) => {
                    this.logger.debug('Success save: ' + data);
                    this.saveDisabled = false;
                    this.dialogController.ok(data);
                }).catch(async (err) => {
                    this.saveDisabled = false;
                    this.logger.debug('Error save: ', err);
                    await Helpers.ParseValidationError(err, this.validationController, this.model);
                });
        }
    }

    cancel() {
        this.dialogController.cancel();
    }
}